/*
This is currently only used on the Slim-based /signin and /settings/account pages
Once those are rebuilt in React, we can delete this wrapper component

2023 update - sign in has been ported to react, waiting on settings page and then this can be deleted.
*/

import React from 'react'
import PropTypes from 'prop-types'

import { Flex } from 'ui/bend'
import AuthProviders from 'components_v2/AuthProviders'

import StyledWrapper from './StyledWrapper'

const StyledAuthProviders = ({ context, authorizations }) => {
  const signIn = context === 'signin'

  // Check for a valid redirect-back param
  // (This should be moved into the React-based SignIn component once it exists)
  const params = new URLSearchParams(window.location.search)
  let redirect = params.get('redirect')
  if (redirect && redirect[0] !== '/') {
    // Relative paths only
    redirect = null
  }

  return (
    <StyledWrapper user={null}>
      <Flex
        alignItems='center'
        flexDirection='column'
        width={signIn ? ['100%', '40%'] : null}
        mx={signIn && 'auto'}
        mb={signIn && ['50px', '100px']}
      >
        <AuthProviders
          context={context}
          authorizations={authorizations}
          signinRedirect={redirect}
        />
      </Flex>
    </StyledWrapper>
  )
}

StyledAuthProviders.propTypes = {
  context: PropTypes.string.isRequired,
  authorizations: PropTypes.object
}

export default StyledAuthProviders
